import { NotificationCard } from './notification-card.tsx';
import { useGetNotificationsQuery } from '@/features/notifications/hooks/queries/get-all-notifications.ts';
import { cn } from '@/utils/utils.ts';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';

export const NotificationList = () => {
  const notificationFilter = useNotificationsStore((state) => state.notificationFilter);
  const { data, isLoading } = useGetNotificationsQuery({ notificationFilter });

  const notifications = data?.pages || [];

  return (
    <ul className="flex flex-col">
      {isLoading && [1, 2, 3, 4, 5].map((item) => <NotificationCardSkeleton key={item} />)}
      {!isLoading &&
        notifications?.map((notification) => (
          <NotificationCard key={notification.notificationId} notification={notification} />
        ))}
    </ul>
  );
};

export const NotificationCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <li className={cn('group relative flex w-full', className)}>
      <div className="w-full">
        <div className="flex w-full gap-2 p-4 py-3">
          <div className="flex-shrink-0">
            <div className="h-10 w-10 animate-pulse rounded-full bg-gray-200" />
          </div>

          <div className="ml-2 min-w-0 flex-1 space-y-2">
            <div className="flex items-center justify-between gap-2">
              <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
            </div>

            <div className="space-y-1">
              <div className="h-3 w-full animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-5/6 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-2/3 animate-pulse rounded bg-gray-200" />
            </div>

            <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
          </div>

          <div className="flex items-center">
            <div className="h-6 w-6 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </li>
  );
};
